import { getApp } from "firebase/app";

export const makeFirebase = () => getApp();
